export default class FederationConfig {
    static fromData(data) {
        if (!data) {
            return;
        }

        let config = new FederationConfig();
        config.id = data.id;
        config.termsOfUse = data.termsOfUse === null ? null : {
            acceptedAt: data.termsOfUse.acceptedAt,
            acceptedBy: data.termsOfUse.acceptedBy,
            version: data.termsOfUse.version,
        };
        config.enabled = config.termsOfUse !== null;

        return config;
    }

    serialize() {
        {
            return {
                kindergarten: this.kindergarten.id,
                basfiNumber: this.basfiNumber,
                costUnit: this.costUnit ? this.costUnit.id : null,
                subventionsEnabled: this.kindergarten.subventionsEnabled,
            }
        }
    }
}
